// extracted by mini-css-extract-plugin
export var card = "read-more-module--card--f1f86";
export var cards = "read-more-module--cards--48882";
export var cta = "read-more-module--cta--6db24";
export var image = "read-more-module--image--c5442";
export var readMore = "read-more-module--read-more--60bfd";
export var text = "read-more-module--text--8ebc9";